import React from "react";
import { FormComponent } from "../../../../../../../../react-core/Html/FormComponent";
import { RelationshipType } from "../../../../../../../../Wrap/Constants/Enums/Customer/RelationshipType";
import { OrganisationMember } from "../../../../../../../../Wrap/Models/Models/Customer/OrganisationMember";
import { Table } from "../../../../../../../Shared/Table/Table";
import { Urls } from "../../../../../../Urls";
import { RelationshipTypeMap } from "../../../../AddClient/Resource/Contents";
import { Navigator } from "../../../../../../../Shared/Wizards/Entities/Navigator";
import { CorrespondenceLightbox } from "./CorrespondenceLightbox";
import { AccountInfoAction } from "../Action/AccountInfoAction";
import { CorrespondenceRecipient } from "../../../../../../../../Wrap/Models/Domains/Account/CorrespondenceRecipient";
import { Lightbox } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { CommonHelper } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { HierarchyIdHelper } from "../../../../../../../Shared/Common/HierarchyIdHelper";
import { HierarchyLevelName } from "../../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { UserStore } from "../../../../../../Stroes/Variable";
import { ToggleButtonTwoOptions } from "../../../../../../../../react-core/Html/ToggleButtonTwoOptions";
import { portfolioDashboardRolesAction } from "../Action/Action";
import { PortfolioDashboardStore } from "../../../Store/Variable";

interface ITrustTableProps {
    trustEntityCustomerId: number;
    data: Array<OrganisationMember>;
    headAccountHierarchyId: string;
    clAccountId: string;
    trustCategory: string;
    hasReadWriteAccessToAdviser: boolean;
    onUpdateClientAccess: VoidFunction;
}

interface ITrustTableState {
    correspondenceRecipient: CorrespondenceRecipient;
    showCorrespondenceLightbox: boolean;
    showErrorMsgLightbox: boolean;
    isEditOnlineAccess: boolean;
    onlineAccessData: OrganisationMember[];
    isLoading: boolean;
}

export class TrustTable extends FormComponent<ITrustTableProps, ITrustTableState> {
    constructor(props: ITrustTableProps) {
        super(props);
        this.state = {
            showCorrespondenceLightbox: false,
            correspondenceRecipient: null,
            showErrorMsgLightbox: false,
            isEditOnlineAccess: false,
            onlineAccessData: null,
            isLoading: false,
        };
    }

    componentDidMount() {
        this.getCorrespondenceRecipient();
    }

    private updateCorrespondenceRecipient(recipient: CorrespondenceRecipient) {
        AccountInfoAction.putCorrespondenceRecipient(recipient, () => {
            this.getCorrespondenceRecipient();
        });
    }

    getCorrespondenceRecipient() {
        AccountInfoAction.getCorrespondenceRecipient(this.props.headAccountHierarchyId, (result) => {
            this.setState({ correspondenceRecipient: result });
        });
    }

    private getHierarchyId(customerId) {
        return HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Customer, customerId);
    }

    render() {
        const { data, headAccountHierarchyId } = this.props;
        const { showCorrespondenceLightbox, correspondenceRecipient, showErrorMsgLightbox } = this.state;
        const canEdit = !UserStore.getUserInfo()?.IsReadOnly && this.props.hasReadWriteAccessToAdviser == true;
        if (CommonHelper.isNullOrEmpty(data)) {
            return <></>;
        }
        return (
            <>
                {showCorrespondenceLightbox && (
                    <CorrespondenceLightbox
                        data={data.filter(
                            (x) =>
                                x.Relationships.includes(RelationshipType.IndividualTrustee) ||
                                x.Relationships.includes(RelationshipType.CorporateTrustee)
                        )}
                        correspondenceRecipient={correspondenceRecipient}
                        headAccountHierarchyId={headAccountHierarchyId}
                        onClose={() => this.setState({ showCorrespondenceLightbox: false })}
                        onCorrespondenceRecipientChange={(val) => this.updateCorrespondenceRecipient(val)}
                    />
                )}
                <h3>Trust members</h3>
                <Table
                    data={data}
                    isLoading={this.state.isLoading}
                    col={[
                        {
                            title: "Name",
                            key: "",
                            render: (data, row: OrganisationMember, index) => {
                                if (row?.Relationships.includes(RelationshipType.CorporateTrustee)) {
                                    return row?.Company?.CompanyName;
                                } else {
                                    return (
                                        row?.Individual?.PersonalDetails?.GivenName +
                                        " " +
                                        row?.Individual?.PersonalDetails?.FamilyName
                                    );
                                }
                            },
                        },
                        {
                            title: "Account number",
                            key: "d",
                            render: (data, row, index) => {
                                return this.props.clAccountId;
                            },
                        },

                        {
                            title: "Account role",
                            key: "Relationships",
                            render: (data) => {
                                return (data || []).map((role) => RelationshipTypeMap[role]).join(" & ");
                            },
                        },
                        {
                            title:
                                !UserStore.getUserInfo()?.IsReadOnly &&
                                this.props.hasReadWriteAccessToAdviser == true ? (
                                    <a
                                        className="hyperlink"
                                        onClick={() => {
                                            this.setState({ showCorrespondenceLightbox: true });
                                        }}
                                    >
                                        Receives correspondence
                                    </a>
                                ) : (
                                    "Receives correspondence"
                                ),
                            key: "CustomerId",
                            render: (data) => {
                                return data == this.state.correspondenceRecipient?.ActorId ? "Yes" : "No";
                            },
                        },
                        {
                            title:
                                !UserStore.getUserInfo()?.IsReadOnly &&
                                this.props.hasReadWriteAccessToAdviser == true ? (
                                    <p className="mb-0">
                                        Online access
                                        <span>
                                            <button
                                                className="edit-circle-icon-button label-sr-only"
                                                onClick={() => {
                                                    this.setState({
                                                        isEditOnlineAccess: !this.state.isEditOnlineAccess,
                                                        onlineAccessData: !this.state.isEditOnlineAccess
                                                            ? JSON.parse(JSON.stringify(this.props.data))
                                                            : null,
                                                    });
                                                }}
                                            >
                                                <span className="icon" aria-hidden="true"></span>
                                                <span className="text">Edit online access</span>
                                            </button>
                                        </span>
                                    </p>
                                ) : (
                                    <p className="mb-0">Online access</p>
                                ),
                            key: "ClientAccess",
                            render: (data, row, index) => {
                                if (this.state.isEditOnlineAccess) {
                                    return (
                                        <ToggleButtonTwoOptions
                                            optionOne={"No"}
                                            optionTwo={"Yes"}
                                            value={this.state.onlineAccessData?.[index]?.ClientAccess}
                                            onChange={(v) => {
                                                const _data = JSON.parse(JSON.stringify(this.state.onlineAccessData));
                                                _data[index].ClientAccess = v;
                                                this.setState({ onlineAccessData: _data });
                                            }}
                                        />
                                    );
                                }
                                return data ? "Yes" : "No";
                            },
                        },
                        !UserStore.getUserInfo()?.IsReadOnly && this.props.hasReadWriteAccessToAdviser == true
                            ? {
                                  title: "Edit",
                                  key: "CustomerId",
                                  render: (data, row: OrganisationMember) => {
                                      return (
                                          <button
                                              className="edit-button label-sr-only"
                                              title="Edit"
                                              onClick={() => {
                                                  if (row?.Company != null) {
                                                      Navigator.navigateTo(
                                                          Urls.get().main.PortfolioDashboard({
                                                              hierarchyId: this.getHierarchyId(data),
                                                          }).OrganisationDetails
                                                      );
                                                  } else {
                                                      Navigator.navigateTo(
                                                          Urls.get().main.PortfolioDashboard({
                                                              hierarchyId: this.getHierarchyId(data),
                                                          }).personalDetail
                                                      );
                                                  }
                                              }}
                                          >
                                              <span className="icon" aria-hidden="true"></span>
                                          </button>
                                      );
                                  },
                              }
                            : null,
                        !UserStore.getUserInfo()?.IsReadOnly && this.props.hasReadWriteAccessToAdviser == true
                            ? {
                                  title: "Remove",
                                  key: "CustomerId",
                                  render: (data, row: OrganisationMember) => {
                                      if (
                                          row?.Relationships.includes(RelationshipType.Settlor) &&
                                          row?.Relationships.length == 1
                                      ) {
                                          return null;
                                      }
                                      if (
                                          row?.Relationships.includes(RelationshipType.IndividualTrustee) &&
                                          row?.Relationships.includes(RelationshipType.Beneficiary) &&
                                          this.props.trustCategory == "Absolute"
                                      ) {
                                          return null;
                                      }
                                      return (
                                          <button
                                              className="remove-button label-sr-only"
                                              title="Delete"
                                              onClick={() => {
                                                  if (data == this.state.correspondenceRecipient?.ActorId) {
                                                      this.setState({ showErrorMsgLightbox: true });
                                                  } else {
                                                      Navigator.navigateTo(
                                                          Urls.get().main.PortfolioDashboard({
                                                              hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                                                  HierarchyLevelName.Customer,
                                                                  this.props.trustEntityCustomerId
                                                              ),
                                                          }).TrustServicing
                                                      );
                                                  }
                                              }}
                                          >
                                              <span className="icon" aria-hidden="true"></span>
                                          </button>
                                      );
                                  },
                              }
                            : null,
                    ].filter((x) => x != null)}
                    showEmptyMsg
                />

                {this.state.isEditOnlineAccess && (
                    <div className="row mt-10">
                        <div className="col-12">
                            <button
                                className="btn primary mr-10"
                                onClick={() => {
                                    portfolioDashboardRolesAction.updateClientAccesses(
                                        this.state.onlineAccessData,
                                        PortfolioDashboardStore.getData()?.[0]?.HierarchyId,
                                        () => {
                                            this.props.onUpdateClientAccess();
                                            this.setState({ isEditOnlineAccess: false, onlineAccessData: null });
                                        }
                                    );
                                }}
                            >
                                Save
                            </button>
                            <button
                                className="btn primary mr-10"
                                onClick={() => {
                                    this.setState({ isEditOnlineAccess: false, onlineAccessData: null });
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                )}

                <div className="page-actions">
                    <div className="action-primary">
                        {canEdit && <button
                            className="btn secondary"
                            onClick={() => {
                                Navigator.navigateTo(
                                    Urls.get().main.PortfolioDashboard({
                                        hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                            HierarchyLevelName.Customer,
                                            this.props.trustEntityCustomerId
                                        ),
                                    }).TrustServicing
                                );
                            }}
                        >
                            <span className="text">Add trust member</span>
                        </button>
                        }
                    </div>
                </div>
                {showErrorMsgLightbox && (
                    <Lightbox
                        noOverlay={false}
                        noAutofocus={true}
                        show={showErrorMsgLightbox}
                        title={"Warning"}
                        unclosable={true}
                        onClose={() => {
                            this.setState({ showErrorMsgLightbox: false });
                        }}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p className="mb-10">You must add a new trustee before removing sole Trustee.</p>
                        <p className="mb-10">
                            Before you remove this Trustee, you must select another address for correspondence to go to.
                        </p>
                        <button
                            className="btn primary  mt-20"
                            onClick={() => {
                                this.setState({ showErrorMsgLightbox: false });
                            }}
                        >
                            OK
                        </button>
                    </Lightbox>
                )}
            </>
        );
    }
}
